import { Box, Grid, Typography } from "@mui/material";
import { RecommendationIcon } from "../Icon";
import makeStyles from '@mui/styles/makeStyles';
import { useEffect, useState } from "react";
import {finalRecommendations} from "../../Constants"

const useStyles = makeStyles((theme) => ({
  mainTypography: {
    fontSize: 17,
    fontWeight: 600,
    color: "#4B4B4B",
  },
  secondTypography: {
    fontSize: 14,
    fontWeight: 600,
    color: "#979797",
  },
  typography: {
    fontSize: 14,
    fontWeight: 600,
    color: "#4B4B4B",
  },
  labelTypography: {
    fontSize: 14,
    fontWeight: 400,
    color: "#4B4B4B",
  },
  icon: {
    marginTop: 10,
  },
  orageBox: {
    backgroundColor: theme.palette.gif.orange.light,
  },
  recommendTypography: {
    fontWeight: 600,
    fontSize: 14,
    marginLeft:10,
  },
  recommendExTpography: {
    fontWeight: 600,
    fontSize: 14,
    marginRight:10,
    float:"right",
  },
}));

const FinalRecommendation = (props) => {
  const classes = useStyles();
  const { proposalReferee } = props;
  const [noteForAdvisors, setNoteForAdvisors] = useState();
  const [recommendation, setRecommendation] = useState({});

  useEffect(() => {
    if (proposalReferee === null || proposalReferee === undefined) return;
    setNoteForAdvisors(proposalReferee.noteForAdvisors);
    let recommendationObj = finalRecommendations.filter(r=>r.value===proposalReferee.refereeFinalRecommend);
    if(recommendationObj.length>0)
        setRecommendation(recommendationObj[0]);
  }, [proposalReferee]);

  return (
    <Box margin={3}>
      <Grid container spacing={1}>
        <Grid item>
          <RecommendationIcon className={classes.icon} />
        </Grid>
        <Grid item>
          <Box textAlign="left" marginLeft={2}>
            <Typography variant="subtitle2" className={classes.mainTypography}>
              FinalRecommendation
            </Typography>
            <Typography
              variant="subtitle2"
              className={classes.secondTypography}
            >
              Sent to the applicant
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12}></Grid>
        <Grid item xs={6} className={classes.orageBox}>
          <Typography className={classes.recommendTypography}>
            {recommendation.label}
          </Typography>
        </Grid>
        <Grid item xs={6} className={classes.orageBox}>
          <Typography className={classes.recommendExTpography}>
          {recommendation.tooltip}
          </Typography>
        </Grid>
        <Grid item xs={12}>
            <Typography className={classes.typography}>Special note to the GIF</Typography>
            <Typography className={classes.secondTypography}>Not sent to the applicant</Typography>
            <Typography className={classes.labelTypography}>
            {noteForAdvisors}
            </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default FinalRecommendation;
